import { Link } from "react-router-dom";

function CtaAbout() {
  return (
    <section className="relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage:
            "url('https://readdy.ai/api/search-image?query=Stylized%20editorial%20manga%20illustration%20of%20an%20open%20comic%20book%20lying%20on%20a%20warm%20wooden%20table%20with%20loose%20pages%20and%20ink%20brushes%20around%2C%20warm%20vermilion%20and%20cream%20ink%20palette%20with%20halftone%20dots%2C%20vintage%20storytelling%20mood%2C%20soft%20warm%20lighting%2C%20high%20detail&width=1600&height=560&seq=cta-about&orientation=landscape')",
        }}
        aria-hidden="true"
      ></div>
      <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-900/85 to-primary-800/80"></div>

      <div className="relative mx-auto flex w-full max-w-7xl flex-col items-start px-4 py-16 md:px-6 md:py-24">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-black/20 px-4 py-1.5 text-xs font-medium text-background-100 backdrop-blur-sm">
          <i className="ri-news-line text-primary-200"></i> 关于本站
        </span>
        <h2 className="mt-5 max-w-2xl font-heading text-2xl font-bold leading-snug text-background-50 md:text-4xl">
          一个专注嘿咻嘿咻漫画的解读与讨论空间
        </h2>
        <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-100/90 md:text-base">
          我们相信，好的故事值得被认真读懂。本站致力于用清晰的剧情解析、扎实的角色档案与真诚的读者讨论，陪每一位追更人把故事看得更透。
        </p>
        <div className="mt-8 flex flex-col gap-3 sm:flex-row">
          <Link
            to="/about"
            className="whitespace-nowrap rounded-md bg-background-50 px-6 py-3 text-sm font-medium text-primary-800 transition-colors hover:bg-accent-100"
          >
            了解我们
          </Link>
          <Link
            to="/reviews"
            className="whitespace-nowrap rounded-md border border-background-50/40 px-6 py-3 text-sm font-medium text-background-50 transition-colors hover:bg-background-50/10"
          >
            看看读者评价
          </Link>
        </div>
      </div>
    </section>
  );
}

export default CtaAbout;